import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import {
  listSessions,
  revokeSession,
  signOutOtherSessions,
} from '@/api/services/auth.service'
import { getErrorMessage } from '@/lib/getErrorMessage'

const sessionsQueryKey = ['auth', 'sessions'] as const

export function useSessions() {
  return useQuery({
    queryKey: sessionsQueryKey,
    queryFn: listSessions,
    staleTime: 30_000,
  })
}

export function useRevokeSession() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (sessionId: string) => revokeSession(sessionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sessionsQueryKey })
      toast.success('Signed out of that device')
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    },
  })
}

export function useSignOutOtherSessions() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => signOutOtherSessions(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sessionsQueryKey })
      toast.success('Signed out of all other devices')
    },
    onError: (error) => {
      toast.error(getErrorMessage(error))
    },
  })
}
